
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.57 3.889V2.722H.39V1.556H3.57V.389H5.48v3.5H3.57zM14.39 2.722V1.556H6.753v1.166h7.636zM9.934 9.14v-3.5H8.025v1.167H.39v1.166h7.636V9.14h1.91zm4.455-1.167V6.806h-3.182v1.166h3.182zm-8.91 6.417v-3.5H3.572v1.167H.389v1.166H3.57v1.167H5.48zm8.91-1.167v-1.166H6.753v1.166h7.636z","fill":"#fff"}})])
          )
        }
      }
    